import TextSymbol from '@arcgis/core/symbols/TextSymbol';

export const createTextSymbol = (text: string): TextSymbol => {
  return new TextSymbol({
    text: text || '',
    color: [255, 255, 255],
    haloColor: [0, 0, 0],
    haloSize: 1,
    font: {
      size: 14,
      family: 'Roboto',
      style: 'normal',
    },
    xoffset: 0,
    yoffset: -20,
  });
};
